import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    bottom: -158px;
    left: 50%;
    z-index: 100;
    height: 160px;
    width: 210px;
    background-color: #111;
    border: 1px solid #333;
    transform: translate3d(-50%, 0, 0);
    transition: all .3s ease 0s;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        bottom: 0;
    }

    &.turnOrderOpened {
        left: calc(50% + 230px);
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    height: 20px;
    border-bottom: 1px solid #333;
    text-transform: uppercase;
    color: #777;
    font-size: 10px;
    padding: 5px;
`;

export const NoTimers = styled.div`
    flex: 1;
    width: 100%;
    color: #666;
    text-align: center;
    padding: 0;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 60px;
        color: #333;
        content: '\\F1862';
        margin: 15px 0;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    gap: 10px;
    padding: 10px;
    border-top: 1px solid #333;
`;

export const Button = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 30px;
    color: ${props => props.color ?? '#0c0'};
    font-size: 14px;
    cursor: pointer;
    transition: all .3s ease 0s;
    border: 1px solid ${props => props.color ?? '#0c0'};

    &:hover {
        background-color: ${props => props.color ?? '#0c0'};;
        color: ${props => props.fontColor ?? '#fff'};;
    }
`;

export const Form = styled.div`
    flex: 1;
    width: 210px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    padding: 0 10px 10px;
`;

export const Label = styled.div`
    text-transform: uppercase;
    font-size: 10px;
    color: #999;
    padding-top: 5px;
    padding-bottom: 0;
    flex: 1;
    margin: 0;
`;

export const Text = styled.div`
    flex: 1;
    height: 25px;
    min-height: 25px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0;
    min-width: 0;
    color: #999;
    border: 1px solid #555;
    background-color: transparent;
`;

export const Input = styled.input.attrs((p) => ({
    type: p.type || 'text',
}))`
    flex: 1;
    height: 25px;
    min-height: 25px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0;
    min-width: 0;
    color: #999;
    border: 1px solid #555;
    background-color: transparent;

    &[type=time]::-webkit-clear-button,
    &[type="time"]::-webkit-calendar-picker-indicator,
    &[type=time]::-webkit-inner-spin-button {
        display: none;
    }
`;

export const Select = styled.select`
    flex: 1;
    height: 25px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0;
    min-width: 0;
    color: #999;
    border: 1px solid #555;
    background-color: transparent;

`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    gap: 10px;
`;

export const TimerList = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    overflow-y: auto;
`;

export const Timer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;    
    padding: 5px;
    cursor: pointer;
    color: #999;

    &.running {
        color: #f62;
    }

    &.paused {
        color: #fff;
    }

    &:hover {
        background-color: #333;
    }
`;

export const TimerType = styled.div`
    height: 32px;
    width: 32px;
    padding: 4px;
    position: relative;
    
    &:before {
        display: flex;
        position: absolute;
        inset: 0;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        color: #999;
        font-size: 24px;
    }

    &.countdown:before {
        content: '\\F02DA';
    }
    &.countup:before {
        content: '\\F0152';
    }
`;

export const TimerLabel = styled.div`
    flex: 1;
`;

export const TimerName = styled.div`
    font-size: 13px;
`;

export const TimerRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
`;

export const TimerState = styled.div`
    flex: 1;
    font-size: 12px;
`;

export const TimerValue = styled.div`
    font-size: 12px;
    color: #999;
`;

export const Icon = styled.div`
    height: 24px;
    width: 24px;
    padding: 0;
    position: relative;
    
    &:before {
        display: flex;
        position: absolute;
        inset: 0;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        color: ${props => props.color ?? '#999'};
        font-size: 20px;
        content: '\\${props => props.icon}';

        &:hover {
            color: ${props => props.fontColor ?? '#fff'};
        }
    }
`;